export enum ChatBotIcons {
  Messenger = 'Messenger',
  Robot = 'Robot',
}
